import React, { useContext } from 'react';

export const TrailerContext = React.createContext({});

export const useTrailer = () => {
  const ctx = useContext(TrailerContext);
  return [ctx.showTrailerModal, ctx.playTrailer, ctx.viewable];
};
